<template>
    <div>
        <status-header></status-header>
        <status></status>
        <footer-view></footer-view>
    </div>
</template>

<script>
    import StatusHeader from "../../components/drowning/StatusHeader";
    import Status from "../../components/drowning/Status";
    import FooterView from "../FooterView";
    export default {
        name: "StatusView",
        components: {FooterView, Status, StatusHeader}
    }
</script>

<style scoped>

</style>